export default __webpack_public_path__ + "static/media/Lshinpad.01f03405.svg";